<template>
  <div 
    :style="{
      marginTop: '-40px',
      width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start'}">
      <div style="width: 100%; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between;">
        <div style="width: 50%; text-align: left;">
          <h3>{{title}}</h3>
        </div>
        
      </div>
      <div style="display: flex; flex-direction: row; width: 100%;">
        <el-select 
            v-if="!$store.getters.isMobileDevice"
            @change="loadLocalFabric"
            default-first-option
            placeholder="scan barcode or type SKU# or article name of the fabric"
            id="fabric_item_search_field"
            remote
            :remote-method="searchSKUCode"
            size="small"
            :loading="getLoading"
            v-model="search_text" filterable style="text-align: left; width: 500px; margin-top: 10px;">
            <el-option
                v-for="(data, index) in $store.getters.getInventoryMasterAutocompleteList"
                :key="index"
                :label="data.sku_code"
                :value="data">
                {{data.id}}
                <span style="float: left" v-html="data.sku_code+' ('+data.article_name+(data.fabric_cut_length === 0 ? '' : ', Cut-Length')+')'"></span>
                <span style="float: right;" v-if="data.closing_stock !== null || data.closing_stock >0 || data.closing_stock < 0"><b :style="'color: '+(data.closing_stock<0 ? 'red' : 'green')">{{data.closing_stock.toFixed(2)}} {{data.unit_name}}</b></span>
            </el-option>
        </el-select>
        <el-input 
            v-else
            id="fabric_item_search_field"
            @focus="$event.target.select()"
            placeholder="type and press ↵ ENTER"
            size="small"
            @keyup.enter.native="searchSKU2"
            style="width: 60%; text-align: left;"
            v-model="search_text">
        </el-input> 
        <!--<el-autocomplete
          v-else
          style="text-align: left; width: 60%; margin-top: 0px;"
          v-model="search_text"
          :fetch-suggestions="searchSKUCode"
          placeholder="Or Search By SKU#"
          :trigger-on-focus="false"
          @select="loadLocalFabric"
        ></el-autocomplete>-->
        <el-tooltip class="item" effect="dark" content="Add new inventory item">
            <a 
                style="cursor: pointer; font-size: 26px; top: 10px; position: relative;"
                @click="checkIfInventoryAddAccessGiven()">
                <i class="el-icon-circle-plus"></i>
            </a>                    
        </el-tooltip>
      </div>
      

      <el-empty v-if="getFabricInfo === null" description="No Data">
      </el-empty>
      <div 
        v-if="getFabricInfo !== null"
        :style="{marginTop: '20px', 
                display: 'flex', 
                flexDirection: 'row', 
                justifyContent: 'flex-start', 
                alignItems: 'flex-start', 
                flexWrap: 'wrap'}">

          <div 
            style="margin: 10px; display: flex; flex-direction: column; justify-content: center; align-items: center; box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
            <DisplayImage 
              :image_width="200" 
              :image_height="200"
              :image_path="getFabricInfo.profile_photo" />
            <span>
              SKU#: {{getFabricInfo.sku_code}}
            </span>
            <span style="font-size: 8px;">
              {{getFabricInfo.article_name}}
            </span>
            <span>
              <span v-if="getFabricInfo.closing_stock !== null && getFabricInfo.closing_stock>0" style="color: green"><i class="el-icon-box"></i> {{getFabricInfo.closing_stock.toFixed(2)}} {{getFabricInfo.unit_name}}</span> 
              <span v-else>-</span>
            </span>
            
            <span v-if="getFabricInfo.sku_code !== undefined">
              {{formatCurrency(getFabricInfo.sale_price)}}
            </span>
            <!--<el-button 
              @click="attachToTailoringItem"
              size="small" 
              icon="el-icon-shopping-cart-2" 
              :style="'color: #ffffff; background-color: #8d8b55;'"><b>Attach</b></el-button>-->
              
          </div>
      </div>
      <el-dialog
        :title="'Create New Fabric Item'"
        fullscreen
        :visible.sync="showInventoryMaster"
        :close-on-press-escape="false"
        append-to-body
        :show-close="false">
            <InventoryMaster 
                :popup="true"
                @closed="closeInventoryWindow"/>
    </el-dialog>

    <el-dialog
        v-if="show_search_window"
        width="70%"
        :visible.sync="show_search_window"
        append-to-body>
        
        <div v-if="$store.getters.getInventoryMasterAutocompleteList.length>0" style="display: flex; flex-direction: column;">

            <div 
                v-for="(data, index) in $store.getters.getInventoryMasterAutocompleteList"
                :key="index"
                @click="loadLocalFabric(data)"
                style="margin: 2px; display: flex; flex-direction: row; justify-content: space-between; align-items: space-between; border-bottom: 1px solid #e2e2e2;">

                  <div style="width: 70%;">
                    <span style="float: left" v-html="data.sku_code+' ('+data.article_name+(data.fabric_cut_length === 0 ? '' : ', Cut-Length')+')'"></span>
                    <span style="float: right;" v-if="data.closing_stock !== null || data.closing_stock >0 || data.closing_stock < 0"><b :style="'color: '+(data.closing_stock<0 ? 'red' : 'green')">{{data.closing_stock.toFixed(2)}} {{data.unit_name}}</b></span>
                  </div>

                  <div style="width: 30%;">
                      <el-button @click="loadLocalFabric(data)" size="small" type="primary">
                          Add >>
                      </el-button>
                  </div>

            </div>

        </div>
        <div v-else>
          <span>No Data Found</span>
        </div>
            
      </el-dialog>

  </div>
</template>

<script>
import InventoryMaster from '../../../InventoryMaster/Form/Index.vue'
import { isMobile } from 'mobile-device-detect';

export default {
  components: {InventoryMaster},
  props: ['title', 'rowData'],
  data() {
    return {
      search_text: '',
      fabric_info: null,
      active: 0,
      showInventoryMaster: false,
      show_search_window: false
    }
  },
  computed: {
      getFabricInfo() {
        return this.rowData.fabric_detail
      },
      getSelectedFabric() {
          return this.$store.state.saleMaster.fabric
      },
      getSearchText() {
        return this.search_text
      },
      getLoading() {
        return this.$store.state.inventoryMaster.loading
      },
      isMobileDevice() {
        return isMobile
      },
      
  },
  methods: {
    closeInventoryWindow($event) {
        this.changeFocus('fabric_item_search_field')
        this.searchSKUCode($event.sku_code)
        this.showInventoryMaster = false
    },
    checkIfInventoryAddAccessGiven() {
        
      if(this.checkIfModuleAccessAvailable('/inventoryproducts', 'can_add')) {
          this.$store.commit('resetInventoryMasterData')
          this.$store.state.inventoryMaster.props.item_type = 1
          this.showInventoryMaster = true
      }
        
    },
    loadLocalFabric($event) {

      this.rowData.fabric_id = $event.id
      this.rowData.fabric_detail = $event
      let fabric_sales_price =  parseFloat($event.sale_price)
      let fabric_actual_rate = fabric_sales_price
      let fabric_price_fixed = false
      if(this.rowData.tailoring_detail.fabric_sales_price_remains_flat === 1) {
          fabric_sales_price = (parseFloat(fabric_sales_price)/parseFloat(this.rowData.required_fabric_unit)).toFixed(2)
          fabric_price_fixed = true
      } else if($event.fabric_price_category_id !== null && $event.fabric_price_category_id>0) {
          fabric_sales_price = (parseFloat(fabric_sales_price)/parseFloat(this.rowData.required_fabric_unit)).toFixed(2)
          fabric_price_fixed = true
      } else if($event.stitching_rate_flat) {
          fabric_sales_price = (parseFloat(fabric_sales_price)/parseFloat(this.rowData.required_fabric_unit)).toFixed(2)
          fabric_price_fixed = true
      } else if($event.fabric_info !== null && $event.default_tailoring_consumption && $event.default_tailoring_consumption>0) {
          this.rowData.fabric_unit_qty = parseFloat($event.default_tailoring_consumption)
      }
      
      this.rowData.fabric_price_fixed = fabric_price_fixed
      this.rowData.fabric_actual_rate = fabric_actual_rate
      this.rowData.fabric_unit_rate = fabric_sales_price
      
      setTimeout(() => {
        this.$store.commit('editRowCalculations')    
        this.closeClicked()  
      }, 300);
      
    },  
    closeClicked() {
      this.$emit('closed')
    },
    async searchSKUCode(query, cb) {
        await this.$store.dispatch('fetchInventoryMasterAutocompleteList', 
        {
            query: query, 
            search_fabric_only: true,
            search_column: ['sku_code', 'article_name'], 
            store_id: this.getWarehouseId>0 ? this.getWarehouseId : this.$store.state.saleMaster.props.store_id
        })

    },
    async searchSKU2() {

        await this.$store.dispatch('fetchInventoryMasterAutocompleteList', 
        {
            query: this.search_text, 
            search_fabric_only: true,
            search_column: ['sku_code', 'article_name'], 
            store_id: this.getWarehouseId>0 ? this.getWarehouseId : this.$store.state.saleMaster.props.store_id
        })
        if(this.isMobileDevice) {
          setTimeout(() => {
            this.show_search_window = true
          }, 300);
        }
    }
  },
  mounted() {
    setTimeout(() => {
      document.getElementById('fabric_item_search_field').focus()
    }, 300);
    this.$store.commit('resetInventoryMasterAutocompleteList')
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/SaleMaster/Form/OrderItem/FabricChange.vue